import axios from 'axios'
import { Message } from 'element-ui'

/**
 * Axios 请求封装
 * 统一处理请求/响应拦截
 */
var service = axios.create({
  baseURL: '',
  timeout: 120000
})

// 请求拦截器
service.interceptors.request.use(
  function(config) {
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  function(response) {
    var res = response.data
    if (res.code !== 200) {
      Message.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  function(error) {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service
